import { inject, Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import { Api } from './api';

// El clock es consulta just abans de pagar: si el servidor no respon, millor
// continuar (el backend valida igualment) que deixar el botó penjat.
const CLOCK_TIMEOUT_MS = 5000;

// Font horària del servidor per al flux "seguro por días": el front no ha de
// calcular mai l'hora amb el rellotge del navegador (clients en altres zones
// horàries o amb el rellotge malament).
export interface SeguroDiasClock {
  now: string;
  today: string;
  timezone: string;
  secondsToMidnight: number;
  blockActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SeguroDiasClockService {
  private readonly api = inject(Api);

  fetch(): Observable<SeguroDiasClock> {
    return this.api.get<SeguroDiasClock>('/seguro-dias/clock').pipe(timeout(CLOCK_TIMEOUT_MS));
  }
}
